import { Box, CircularProgress } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export interface LoaderPropTypes{
  size?: number;
}

const Loader: React.FC<LoaderPropTypes> = (props) => {
  const theme = useTheme();
  const {size} = props;

  return (
    <Box sx={{ display: "flex" }}>
      <CircularProgress size={size ? size : 50} sx={{ color: theme?.color?.secondary }} />
    </Box>
  );
};

export default Loader;
